import React from 'react';
import { Box, Button } from '@mui/material';

interface Props {
  isSubmitDisabled: boolean;
  handleSubmit: () => void;
  handleCancel: () => void; // New prop for cancel action
}

const FormButtons: React.FC<Props> = ({ isSubmitDisabled, handleSubmit, handleCancel }) => (
  <Box className="form-buttons">
    <Button
      aria-label="Submit Form"
      variant="contained"
      color="primary"
      disabled={isSubmitDisabled}
      onClick={handleSubmit}
    >
      Submit
    </Button>
    <Button
      aria-label="Cancel Form changes"
      variant="outlined"
      color="secondary"
      onClick={handleCancel} // Trigger the cancel handler
    >
      Cancel
    </Button>
  </Box>
);

export default FormButtons;
